
import { Base } from '../base-component';
import './file-list-filter-none.component.scss';

export class FileListFilterNone extends Base {

	detailBlocks: any;
	
	constructor(element: Element){

		super(element)
				
	}

	init(){

		this.detailBlocks = Array.from(this.element.querySelectorAll('.file-list-filter-none__detail'));

		this.checkEmptyContainers();

	}
		
	bindEvents(){}

	checkEmptyContainers() {

		this.detailBlocks.map((item, index)=>{

			let text = item.textContent;
			let content = text.trim().replace(/ /g, '');
			
			if(content === ''){

				item.classList.add('file-list-filter-none__detail--no-border')
				
			}

		})

	}

}


// WEBPACK FOOTER //
// ./components/file-list-filter-none/file-list-filter-none.component.ts